import React, { useCallback, useMemo } from "react";
import { getLoginDialogTitleAndDescription, getShouldShow } from "~/components/acquisition-popup-container/display/helpers";
import { useSdkContext } from "~/components/contexts";
import { parseConfigFromQueryAction } from "./actions";
import { SanitizedUrlKeys } from "./consts";
import { TopicPackageFollowPopup } from ".";
export function useTopicPackageFollowPopupGetter(options) {
  const {
    acquisition: {
      popupState
    },
    currentRoute,
    handleOpenLoginDialog,
    handleRemoveRouteQuery: handleRemoveRouteQuery_,
    userCountry,
    userTypeIds
  } = useSdkContext();
  const handleRemoveRouteQuery = useCallback(() => handleRemoveRouteQuery_(SanitizedUrlKeys), [handleRemoveRouteQuery_]);
  const getNextFromAction = useCallback(handleClose => {
    const parsedConfig = parseConfigFromQueryAction(new URL(currentRoute, window.location.origin).search);
    if (!parsedConfig) return;
    const matchedConfig = popupState.topicPackageFollows[parsedConfig.configKey];
    if (!matchedConfig) return;
    if (!options.isLoggedIn) {
      const {
        description,
        title
      } = getLoginDialogTitleAndDescription({
        campaignName: matchedConfig.displayName,
        type: "topics"
      });
      handleOpenLoginDialog({
        description,
        destination: window.location.href,
        ga4CustomParameter: {
          internal_campaign: matchedConfig === null || matchedConfig === void 0 ? void 0 : matchedConfig.trackingActionName,
          trigger_point: "ppto"
        },
        title
      });
      void handleRemoveRouteQuery();
      return;
    }
    const props = {
      confirmedConfig: {
        checkedItemIndex: parsedConfig.checkedIndex
      },
      modalContainerReference: options.modalContainerReference,
      onClose: handleClose,
      topicPackageFollow: {
        ...matchedConfig,
        key: parsedConfig.configKey
      }
    };
    void handleRemoveRouteQuery();
    return {
      element: /*#__PURE__*/React.createElement(TopicPackageFollowPopup, props),
      localStorageKey: matchedConfig.localStorageKey
    };
  }, [currentRoute, handleOpenLoginDialog, handleRemoveRouteQuery, options.isLoggedIn, options.modalContainerReference, popupState.topicPackageFollows]);
  const getNextFromConfig = useCallback(handleClose => {
    const nextConfig = Object.entries(popupState.topicPackageFollows).find(([_, config]) => getShouldShow({
      config,
      userInfo: {
        isLoggedIn: options.isLoggedIn,
        userCountry: userCountry !== null && userCountry !== void 0 ? userCountry : "",
        userTypeIds
      }
    }));
    if (!nextConfig) return;
    const [key, config] = nextConfig;
    const props = {
      modalContainerReference: options.modalContainerReference,
      onClose: handleClose,
      topicPackageFollow: {
        ...config,
        key
      },
      trackingName: config.trackingActionName
    };
    return {
      delay: Number.parseInt(config.timeout, 10),
      element: /*#__PURE__*/React.createElement(TopicPackageFollowPopup, props),
      localStorageKey: config.localStorageKey
    };
  }, [options.isLoggedIn, options.modalContainerReference, popupState.topicPackageFollows, userCountry, userTypeIds]);
  const getters = useMemo(() => ({
    getNextFromAction,
    getNextFromConfig
  }), [getNextFromConfig, getNextFromAction]);
  return getters;
}